//
// This file is part of the TYPO3 CMS-based extension "memorial".
// (c) Earlybird GmbH <typo3@earlybird.at>
//
import { Icon, IconOptions } from 'leaflet';

export class LargeMapIcon extends Icon {
  // Icons (Markers) should at least of size 48x48 px (Lighthouse; 24px axe/SC 2.5.8)
  // the actual size of the image is defined via CSS using `leaflet-marker-icon--*`.

  constructor(options: IconOptions) {
    options.iconSize = [48, 48]; // 36x40
    options.iconAnchor = [24, 38]; // '18, 36' for 36x40
    options.popupAnchor = [0, -28]; // '0, -28' for 36x40
    options.className = 'leaflet-marker-icon--large';
    super(options);
  }
}

export class MediumMapIcon extends Icon {
  constructor(options: IconOptions) {
    options.iconSize = [48, 48]; // 28x32
    options.iconAnchor = [24, 35]; // '24, 44' for 28x32
    options.popupAnchor = [0, -19]; // '0, -19' for 28x32
    options.className = 'leaflet-marker-icon--medium';
    super(options);
  }
}
